export const GENDER_LIST = [
    {
        id: 'm',
        name: 'gender.m',
    },
    {
        id: 'f',
        name: 'gender.f',
    },
];

export const OPT_IN_LIST = [
    {
        id: 'Yes',
        name: 'optIn.yes',
    },
    {
        id: 'No',
        name: 'optIn.no',
    },
];

export const SMS_OPT_OUT_LIST = [
    {
        id: 'yes',
        name: 'smsOptOut.yes',
    },
    {
        id: 'no',
        name: 'smsOptOut.no',
    },
];

export const TRAVEL_FREQUENTFLYER_LIST = [
    'Skymiles Number (Delta)',
    'Mileage Plus (United)',
    'TrueBlue (JetBlue)',
    'AAdvantage Number (American Airlines)',
    'Elevate Number (Virgin)',
    'Rapid Rewards (Southwest)',
    'Frequent Flyer (US Airways)',
];

export const TRAVEL_SEAT_LIST = [
    'No Preference',
    'Window',
    'Middle',
    'Aisle',
];

export const TRAVEL_TIME_LIST = [
    'I\'m flexible',
    '6AM-10AM',
    '10AM-2PM',
    '2PM-6PM',
    '6PM-10PM',
];
